const MADURAI_ROUTE_COPY = {
  Coimbatore: {
    leaveHero:
      'Book a one-way taxi from Madurai to Coimbatore, then edit pickup or drop if you need a tighter address.',
    returnHero:
      'Leave Coimbatore for Madurai in a one-way cab. Pickup and drop are set for this inbound leg and stay editable.',
    leaveIntro: [
      'Madurai to Coimbatore is a westbound outstation taxi across Tamil Nadu, typically booked when temple, family or work time in Madurai is finished and you still need a door-to-door cab into Coimbatore. This page is only that Madurai-origin leg.',
      'Pickup starts as Madurai. Change it to Madurai Airport, a hotel or another mapped point if that is where you will wait. Drop starts as Coimbatore and can be narrowed before you estimate.',
      'This pair is not one of the locked Coimbatore-origin catalogue URLs. Fare still comes from the live mapped drive, the published per-kilometre tariff and driver bata — not a Madurai package.',
    ],
    returnIntro: [
      'Coimbatore to Madurai is the ride into the temple city, not a rewrite of the outbound Madurai page. Use it when you are already in Coimbatore and only need that eastbound taxi.',
      'The form opens with Coimbatore pickup and Madurai drop. Replace either field for a neighbourhood, airport or hotel. This URL is separate from Coimbatore’s existing 54 destination pages, which do not include Madurai.',
      'One Way stays selected so you are not holding a return vehicle in Madurai unless you switch the card to Round Trip.',
    ],
    leaveTravel:
      'You stay in one cab from your Madurai pickup through to Coimbatore. Distance and time are mapped live for this direction rather than reused from another city’s catalogue kilometre.',
    returnTravel:
      'The return starts in Coimbatore and continues to Madurai as its own mapped drive. This page does not copy the outbound kilometre or treat both directions as the same trip.',
    leaveMeta:
      'Book a one-way Madurai to Coimbatore taxi with Easy Drop Taxi. Pickup starts in Madurai, drop in Coimbatore, and the fare uses the live online estimate.',
    returnMeta:
      'Book a one-way Coimbatore to Madurai taxi with Easy Drop Taxi. Pickup starts in Coimbatore, drop in Madurai, and both fields stay editable in the existing form.',
    leaveFaqs: [
      {
        question: 'Can I start this Madurai to Coimbatore taxi from the airport?',
        answer:
          'Yes. Change pickup to Madurai Airport or another airport address, keep Coimbatore as drop or edit it, then continue with Get Fare Estimate.',
      },
      {
        question: 'Is this the same as a Coimbatore catalogue route?',
        answer:
          'No. Coimbatore’s locked destination list does not include Madurai. This landing is the Madurai–Coimbatore pair. Open a Coimbatore-origin page only when you are actually leaving Coimbatore for one of those listed cities.',
      },
    ],
    returnFaqs: [
      {
        question: 'Can I finish this Coimbatore to Madurai taxi at Madurai Airport?',
        answer:
          'Yes. Keep Coimbatore as pickup or edit it, change drop to Madurai Airport if that is where you will alight, then estimate as usual.',
      },
      {
        question: 'Does this reverse page copy the outbound Madurai kilometre?',
        answer:
          'No. Coimbatore to Madurai is mapped on its own when you search. The outbound Madurai to Coimbatore page is a separate URL.',
      },
    ],
  },
  Bangalore: {
    leaveHero:
      'Travel one way from Madurai to Bangalore in an Easy Drop Taxi cab, with both locations editable before you search.',
    returnHero:
      'Start in Bangalore and book a one-way taxi to Madurai when you are ready to leave Karnataka for southern Tamil Nadu.',
    leaveIntro: [
      'Madurai to Bangalore is an interstate outstation drop from the temple city into Karnataka. Travellers usually want a single vehicle for the full run rather than changing at a bus stand, and a one-way booking so the cab is not held for a return they will not take.',
      'Pickup defaults to Madurai. Drop defaults to Bangalore. Type a more specific start or finish — a hotel, Bangalore Airport or another mapped point — if that is where you will actually board or alight.',
      'Sample figures on this page appear only after live mapping. They are not a Bangalore package and they are not taken from the Coimbatore–Bangalore catalogue page.',
    ],
    returnIntro: [
      'Bangalore to Madurai is for leaving Karnataka toward Madurai. It is a separate landing page because the drive is mapped from Bangalore pickup, not copied from the outbound Madurai start.',
      'Keep or edit Bangalore as pickup and Madurai as drop. Airport pickup in Bangalore is a field edit; that name already exists in Easy Drop Taxi’s city list.',
      'Vehicle rates remain the published per-kilometre tariff plus driver bata. Interstate extras such as permit or toll stay as shown on the review screen.',
    ],
    leaveTravel:
      'The outbound taxi runs from Madurai to Bangalore as one booked vehicle. Distance and time on this page come from the live map for that pickup and drop.',
    returnTravel:
      'You board in Bangalore and continue to Madurai without reusing the outbound map. If mapping is unavailable, use Get Fare Estimate in the booking card.',
    leaveMeta:
      'Book a Madurai to Bangalore one-way taxi with Easy Drop Taxi. Use the online form for pickup, drop and a live fare estimate into Karnataka.',
    returnMeta:
      'Book a Bangalore to Madurai one-way taxi. Reverse-route defaults are pre-filled for leaving Bangalore toward Madurai, and both locations remain editable.',
    leaveFaqs: [
      {
        question: 'Does this page use the Coimbatore to Bangalore taxi URL?',
        answer:
          'No. That pair already has its own Coimbatore slug. This page is only Madurai to Bangalore. Open the Coimbatore landing if you are actually starting in Coimbatore.',
      },
      {
        question: 'Can I finish at Bangalore Airport?',
        answer:
          'Yes. Drop starts as Bangalore. Change it to Bangalore Airport or another mapped terminal address before you estimate.',
      },
    ],
    returnFaqs: [
      {
        question: 'Can I start from Bangalore Airport rather than the city name?',
        answer:
          'Yes. Pickup defaults to Bangalore but you can type Bangalore Airport or another mapped point before you estimate.',
      },
      {
        question: 'Is this the same booking as Madurai to Bangalore?',
        answer:
          'No. This page is only the Bangalore to Madurai leg. Use the outbound URL when you are leaving Madurai.',
      },
    ],
  },
  Vellore: {
    leaveHero:
      'Book a one-way Madurai to Vellore taxi online, then edit pickup or drop if you have a precise address.',
    returnHero:
      'Leave Vellore for Madurai in a one-way cab through the same Easy Drop Taxi booking form.',
    leaveIntro: [
      'Madurai to Vellore is a long northbound Tamil Nadu taxi, often used for college, hospital or family travel rather than a local Madurai hire. This page is not the Coimbatore to Vellore pair.',
      'Pickup starts in Madurai. Drop starts as Vellore. Change pickup if you are leaving from a hotel or Madurai Airport. Change drop if you need a campus, hospital or another mapped point in Vellore.',
      'Fare still follows billed live kilometres, the published vehicle rate and driver bata. Toll and any extras stay as shown when you review.',
    ],
    returnIntro: [
      'Vellore to Madurai is the southbound taxi after time in Vellore. Book it when you only need that inbound ride, not a round trip held from Madurai.',
      'The card opens on Vellore pickup and Madurai drop. Both fields stay editable. One Way is the default because this page is the reverse leg.',
      'Live mapping for Vellore to Madurai is loaded on this page independently. Do not treat the outbound Madurai kilometre as the return figure.',
    ],
    leaveTravel:
      'You leave Madurai and continue in the same taxi toward Vellore. Travel time depends on the live mapped drive and traffic, not a catalogue hour.',
    returnTravel:
      'The inbound taxi starts in Vellore and finishes in Madurai. Mapping for this reverse is separate from the Madurai-origin page.',
    leaveMeta:
      'Book a one-way Madurai to Vellore taxi with Easy Drop Taxi. Pickup starts in Madurai, drop in Vellore, and the fare uses the live mapped estimate.',
    returnMeta:
      'Book a Vellore to Madurai one-way taxi with Easy Drop Taxi. Pickup starts in Vellore, drop in Madurai, and both locations stay editable.',
    leaveFaqs: [
      {
        question: 'Is this the same page as Coimbatore to Vellore?',
        answer:
          'No. That pair already exists on its own Coimbatore URL. Use this page only when pickup is Madurai (or a Madurai address you type).',
      },
      {
        question: 'Can I change drop to a hospital or college in Vellore?',
        answer:
          'Yes. The drop field accepts a more specific mapped place. Neighbourhood lists are not invented on this page.',
      },
    ],
    returnFaqs: [
      {
        question: 'Can I leave from a specific point in Vellore?',
        answer:
          'Yes. Pickup is pre-filled as Vellore and stays editable for a hotel, hospital or another mapped address.',
      },
      {
        question: 'Should I use the Madurai to Vellore page for the return?',
        answer:
          'No. Book Vellore to Madurai here. The outbound Madurai page is a different URL with a different pickup default.',
      },
    ],
  },
  Tirupati: {
    leaveHero:
      'Book a one-way taxi from Madurai to Tirupati, then edit pickup or drop if you need a more specific address.',
    returnHero:
      'Leave Tirupati for Madurai in a one-way cab. Pickup and drop are pre-filled for this return leg and stay editable.',
    leaveIntro: [
      'Madurai to Tirupati is an interstate temple-town taxi from Tamil Nadu into Andhra Pradesh. It is booked as one vehicle for the pilgrimage or family drop, not as a local Madurai round.',
      'Pickup defaults to Madurai. Drop defaults to Tirupati — the spelling used on this landing page. You can accept a map suggestion for a lodging or temple-side point before you estimate.',
      'This is not the Coimbatore to Tirupati catalogue URL. That pair keeps its own spelling and slug. Fare here still uses live mapping plus the published tariff and driver bata.',
    ],
    returnIntro: [
      'Tirupati to Madurai is for leaving the temple town toward Madurai. It is a separate page because pickup starts in Tirupati, not in Madurai, and the drive is mapped in this direction.',
      'Keep or edit Tirupati as pickup and Madurai as drop. Airport or hotel edits are field changes, not a second booking system.',
      'One Way is the default so you are not holding a cab in Madurai unless you switch to Round Trip. Permit and toll extras remain as already noted at review.',
    ],
    leaveTravel:
      'You leave Madurai and continue in the same taxi toward Tirupati. Distance on this page comes from the live map for that pickup and drop, not from the Coimbatore Tirupati catalogue.',
    returnTravel:
      'You board in Tirupati and continue to Madurai as its own mapped drive. This reverse does not reuse the outbound Madurai kilometre.',
    leaveMeta:
      'Book a one-way Madurai to Tirupati taxi with Easy Drop Taxi. Pickup starts in Madurai, drop in Tirupati, and the fare uses the live online estimate.',
    returnMeta:
      'Book a one-way Tirupati to Madurai taxi with Easy Drop Taxi. Pickup starts in Tirupati, drop in Madurai, and both fields stay editable.',
    leaveFaqs: [
      {
        question: 'Is this the same as the Coimbatore to Tirupati taxi page?',
        answer:
          'This pair uses the Tirupati spelling in the URL and booking defaults. Coimbatore’s catalogue uses Tirupati on a different slug. Open that Coimbatore page only when you are actually leaving Coimbatore.',
      },
      {
        question: 'Can I finish near the temple area in Tirupati?',
        answer:
          'Yes. Drop is a starting label. Type a lodging or other mapped place before you estimate. This page does not invent a temple-coverage list.',
      },
    ],
    returnFaqs: [
      {
        question: 'Can I start from lodging in Tirupati rather than the town name?',
        answer:
          'Yes. Pickup defaults to Tirupati but you can type a hotel or another mapped point before you estimate.',
      },
      {
        question: 'Does this reverse copy the Madurai to Tirupati kilometre?',
        answer:
          'No. Tirupati to Madurai is mapped when you search on this page. The outbound Madurai URL is a different booking start.',
      },
    ],
  },
};

export const getMaduraiRouteProfile = (place) => MADURAI_ROUTE_COPY[place] || null;

export const MADURAI_EXTRA_DESTINATIONS = ['Coimbatore', 'Bangalore', 'Vellore', 'Tirupati'];

export const MADURAI_ROUTE_HUB = 'Madurai';
